namespace advisorop.components.advisor {

    export class AdvisorRtgDashboardController {
        $router;
        showAssetAllocation = 1;
        accounts;
        annuityAccounts = [];
        noPerformanceAccounts;
        noAssetAllocHistAccounts;
        accountsWithHoldingsInfo;
        rtg: domains.IAccountGroup;
        rtgId: number;
        analysts: Array<domains.ISalesforceAnalystData> = [];
        accountGroupType: domains.AccountGroupType = domains.AccountGroupType.RTG; //RTG always 
        mvDate: Date = null;
        perfDate: Date = null;
        chartData: Array<domains.IChartDataSource>;
        chrData: Array<domains.IChartDataSource>;
        allowHistCharts: boolean = true;
        showHistChart: boolean = false;
        histChartView: boolean = false;
        histChrData = [];
        histChartData = []
        histChartType: string = "1";
        histChartDateType: string = "1";
        dg: DevExpress.ui.dxDataGridOptions;
        hdg: DevExpress.ui.dxDataGridOptions;
        dashboardType: domains.DashboardType = domains.DashboardType.ACCOUNTGROUP;
        performanceDetailsPtp: any[]; // performance detail for P2P datagrid
        ptpCaption: string = "Please choose a date range and click Apply";
        ptpCaption2: string = null;
        ptpLineCaption: string = null;
        fromDate: Date;
        toDate: Date;
        activeTab: number = 1;
        loadingP2PPerformanceLadda: boolean = false;
        showClosedInactive: boolean = true;
        chartHDAccountsController: advisorop.components.widgets.ChartHdAccountsController;
        asg: AccountSummaryGridController;

        chartDataParams: {
            level?: string,
            householdId?: number,
            accountGroupType?: number,
            groupId?: number,
            accountId?: number,
            boModelId?: number,
            showClosedInactive?: boolean,
            additionalData?: string
        }

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#rtgContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        chartDataLoading: boolean = false;
        chartLoadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#rtgChartContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Retrieving data...",
            bindingOptions: {
                visible: "vm.chartDataLoading"
            }
        }

        ctlAccountDdl: advisorop.components.common.AccountsDdlController;

        static $inject = ["advisorService", "accountGroupApi", "householdApi", "advisorDashboardService", `acgHelper`, "generalService"];
        constructor(
            private advisorService: services.AdvisorService,
            private acgApi: services.AccountGroupApi,
            private hhApi: services.HouseholdApi,
            private ads: services.AdvisorDashboardService,
            private acgs: services.AcgHelper,
            private gs: services.GeneralService) {
            this.chartData = this.ads.getEmptyChartData();
            this.histChartData = [];
            this.chartDataParams = {
                level: null,
                householdId: null,
                accountGroupType: null,
                groupId: null,
                accountId: null,
                boModelId: null,
                showClosedInactive: null,
                additionalData: null
            };
            this.dg = {
                export: {
                    enabled: false,
                    fileName: "NoPerformanceAccounts"
                },
                bindingOptions: {
                    dataSource: "vm.noPerformanceAccounts"
                },
                //height: "350px",
                paging: {
                    pageSize: 20,
                    enabled: true
                },
                scrolling: {
                    mode: "infinite",
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                noDataText: "There are no accounts",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'accountName', caption: 'Account name', cellTemplate: 'colFullName' }
                ]
            };
            this.hdg = {
                export: {
                    enabled: false,
                    fileName: "NoAssetAllocHistAccounts"
                },
                bindingOptions: {
                    dataSource: "vm.noAssetAllocHistAccounts"
                },
                //height: "350px",
                paging: {
                    pageSize: 20,
                    enabled: true
                },
                scrolling: {
                    mode: "infinite",
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                noDataText: "There are no accounts",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'accountName', caption: 'Account name', cellTemplate: 'colFullName2' }
                ]
            };
        }

        loadRtgCharts(): void {
            this.hhApi.getCharts(this.chartDataParams.householdId, this.chartDataParams.accountGroupType, this.chartDataParams.level, this.chartDataParams.groupId, null, null, true, false, this.histChartView)
                .then((data) => {
                    this.chrData = data.data.chartData;

                    this.chrData.map(v => v.chart.caption = this.chartDataParams.additionalData);

                    this.chartData = this.chrData;
                });
        };

        // Updates the structure in place
        setVisibilityOfData(dataSet: Array<domains.IStackedBarChartDataset>, histChartType: string) {
            if (histChartType == "1" || histChartType == "2") {
                // percentage or value based = show all
                dataSet.forEach(function (r, a) {
                    if (r)
                        r.visible = "1";
                });
            } else if (histChartType == "3") {
                // Hide Value Line
                dataSet.forEach(function (r, a) {
                    if (r) {
                        if (r.seriesname == "Total Value")
                            r.visible = "0";
                        else
                            r.visible = "1";
                    }
                });
            } else if (histChartType == "4") {
                // Show Value Line Only
                dataSet.forEach(function (r, a) {
                    if (r) {
                        if (r.seriesname == "Total Value")
                            r.visible = "1";
                        else
                            r.visible = "0";
                    }
                });
            }
        }

        toggleDataVisibility() {
            // show or hide the line chart data based on the options selected by the user. 
            this.histChrData.forEach(v => { if (v.dataset && v.dataset.length > 0) this.setVisibilityOfData(v.dataset, this.histChartType); });
        }

        setStackPercentAttribute() {
            if (this.chartHDAccountsController) {
                this.chartHDAccountsController.setChartAttributes(this.histChartType);
            }
        }

        // Sum across like indexes for each series to compute the total for each series and
        // return the line-chart series definition that we can append to the chart dataset structure.
        createLineChartDataset(dataSet: Array<domains.IStackedBarChartDataset>): domains.IStackedBarChartDataset {

            // Initialize an empty chart dataset data structure
            let chartDatasetData: Array<domains.ChartDatasetData> = [];
            if (dataSet && dataSet.length > 0 && dataSet[0].data && dataSet[0].data.length > 0) {
                dataSet[0].data.forEach(f => {
                    var d: domains.ChartDatasetData = { value: 0 };
                    chartDatasetData.push(d);
                });
                // Populate the structure, summing across all of the series
                dataSet.forEach(function (r, a) {
                    r.data.forEach(function (b, i) {
                        chartDatasetData[i].value = (chartDatasetData[i]?.value || 0) + b.value;
                    });
                });
                // Return dataset, specified as line plot
                const ret: domains.IStackedBarChartDataset = {
                    seriesname: "Total Value",
                    renderas: "Line",
                    showvalues: "1",
                    data: chartDatasetData
                };

                return ret;
            }
            return null;
        }

        updateHistChartData() {
            if (this.histChrData && this.histChrData.length > 0 && this.histChrData[0].dataset.length > 0) {
                this.histChartData = [];
                //console.log("HISTCHRDATA", this.histChrData);
                angular.copy(this.histChrData, this.histChartData);
            }
        }

        bindChartHDAccountsWidget(ctrl: advisorop.components.widgets.ChartHdAccountsController) {
            this.chartHDAccountsController = ctrl;
            this.setStackPercentAttribute();
        }

        loadSelectedChartData() {
            this.chartDataLoading = true;

            var dateTypeParam: domains.HistChartDateType;
            if (this.histChartDateType == "1")
                dateTypeParam = domains.HistChartDateType.LAST_SIX_MONTHS;
            else if (this.histChartDateType == "2")
                dateTypeParam = domains.HistChartDateType.LAST_FOUR_QUARTERS;
            else
                dateTypeParam = domains.HistChartDateType.LAST_ONE_WEEK;

            //const getHdChartPromise = this.ads.getHdChartPromise(this.chartDataParams.level, this.chartDataParams.householdId, this.chartDataParams.accountGroupType, this.chartDataParams.groupId, this.chartDataParams.accountId, this.chartDataParams.boModelId, this.chartDataParams.showClosedInactive, this.histChartView, dateTypeParam);
            //
            //// load HD chart data 
            //if (getHdChartPromise != null) {
            //    getHdChartPromise.then(response => {
            if (this.chartHDAccountsController) {
                this.chartHDAccountsController.clearHistChartData = true;
                this.histChartData = [];
            }
            this.ads.getHdChartPromise(this.chartDataParams.level, this.chartDataParams.householdId, this.chartDataParams.accountGroupType, this.chartDataParams.groupId, this.chartDataParams.accountId, this.chartDataParams.boModelId, this.chartDataParams.showClosedInactive, this.histChartView, dateTypeParam)
                .then(response => {
                    if (!response || !response.data || !response.data.chartData || response.data.chartData.length <= 0) {
                        this.hideAssetAllocationPanelAndEmptyData();
                    } else {
                        this.updateChartData(response, this.chartDataParams.additionalData);
                        if (this.histChartView && this.allowHistCharts && !this.showHistChart) {
                            this.showHistChart = true;
                        }
                    }
                }).finally(() => {
                    this.chartDataLoading = false;
                });
        }

        hideAssetAllocationPanelAndEmptyData = () => {
            console.log("There are no charts...");
            this.showAssetAllocation = 0;
            this.ctlAccountDdl.selItemID = "no data";
            this.ctlAccountDdl.selItemData = null;
            this.chartData = this.ads.getEmptyChartData();
        }

        updateChartData = (response: ng.IHttpPromiseCallbackArg<any>, additionalData) => {
            if (!response || !response.data || !response.data.chartData || response.data.chartData.length <= 0) {
                this.hideAssetAllocationPanelAndEmptyData();
                return;
            }
            this.showAssetAllocation = 1;
            this.chrData = response.data.chartData;
            this.chrData.map(v => v.chart.caption = additionalData);
            this.chartData = this.chrData;
            if (this.histChartView == true) {
                this.histChrData = response.data.histChartData;
                if (this.histChrData && this.histChrData.length > 0 && this.histChrData[0].dataset.length > 0) {
                    this.histChrData.forEach(v => v.dataset?.push(this.createLineChartDataset(v.dataset)));
                    if (this.chartHDAccountsController)
                        this.chartHDAccountsController.histChartDataExists = true;
                    this.toggleDataVisibility();
                    this.updateHistChartData();
                } else {
                    if (this.chartHDAccountsController)
                        this.chartHDAccountsController.histChartDataExists = false;
                }
            }
        }

        histChartsToggle(toggle: boolean) {
            this.allowHistCharts = toggle;
            if (toggle == true) {
                if (this.histChartView && !this.showHistChart) {
                    this.showHistChart = true;
                }
            } else {
                this.showHistChart = false;
            }
        }

        hg_onItemSelected(item, level, additionalData) {

            // console.log(`hg_onItemSelected: level:${level}, group:${item.groupId}, account:${item.accountId}, sleeve:${item.boModelId}`);

            if (!this.rtg) {
                //console.log(`hg_onItemSelected: Rtg not loaded.`);
                return;
            }

            if (!this.ctlAccountDdl) {
                //console.log(`hg_onItemSelected: AccountDll has not been initialised yet...`);
                return;
            }

            this.chartDataParams.level = level;
            this.chartDataParams.householdId = this.rtg.householdId;
            this.chartDataParams.accountGroupType = this.accountGroupType;
            this.chartDataParams.groupId = item.groupId;
            this.chartDataParams.accountId = item.accountId;
            this.chartDataParams.boModelId = item.boModelId;
            this.chartDataParams.showClosedInactive = this.showClosedInactive;
            this.chartDataParams.additionalData = additionalData;

            this.loadSelectedChartData();

            if (level == "R") {
                this.ctlAccountDdl.setSelItemId(`${item.groupId}`);
                this.histChartsToggle(true);
            }
            else if (level == "A") {
                this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}`);
                //if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && item.manualHoldingsExSystem == true)
                //    this.hideAssetAllocationPanelAndEmptyData();
                if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT)
                    this.histChartsToggle(false);
                else
                    this.histChartsToggle(true);
            }
            else if (level == "S") {
                this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}_${item.boModelId}`);
                //if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && item.manualHoldingsExSystem == true)
                //    this.hideAssetAllocationPanelAndEmptyData();
                if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT)
                    this.histChartsToggle(false);
                else
                    this.histChartsToggle(true);
            }
            //else {
            //    // OA - outside investment accounts where holdings are maintained outside of AdvisorOp,
            //    // we can not show asset allocation for these because they all share the same Security ID
            //    this.hideAssetAllocationPanelAndEmptyData();
            //    if (item.boModelId > 0) {
            //        this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}_${item.boModelId}`);
            //    } else {
            //        this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}`);
            //    }
            //}
        }


        $onInit(): void {
            // default from-date to 2 days ago
            this.fromDate = new Date();
            this.fromDate.setDate(this.fromDate.getDate() - 2);
            // default to-date to yesterdaony
            this.toDate = new Date();
            this.toDate.setDate(this.toDate.getDate() - 1);
        }

        loadAccounts(): void {
            this.mvDate = null;
            this.isInitializing = true;
            this.acgApi.getAccounts(this.rtgId, false).then((data) => {
                this.accounts = data.data.gridData;
                this.noPerformanceAccounts = this.accounts.filter(f => f.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && f.manualHoldingsExSystem === false);
                this.noAssetAllocHistAccounts = this.accounts.filter(f => f.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && f.manualHoldingsExSystem == false);

                this.annuityAccounts = [];
                if (data.data.hasOwnProperty('annuityAccounts') && data.data.annuityAccounts.length > 0)
                    this.annuityAccounts = data.data.annuityAccounts;

                this.isInitializing = false;
                // preparing data structure for DropDown-TreeView content
                if (this.ctlAccountDdl) {
                    //console.log(`Preparing data for DDL...`);
                    this.ctlAccountDdl.prepareDropDownData(this.accounts);
                    this.ctlAccountDdl.setSelItemId(`${this.rtgId}`);
                }

                if (this.accounts.length > 0) {
                    // The Market Value Date on all account rows is the same (date from the BO table), so we can take the date from the first row.
                    this.mvDate = this.accounts[0].marketValueDate;
                }
            }, err => this.isInitializing = false);
        };

        formatFromDate(): string {
            //var utcDate: Date = new Date(Date.UTC(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate()));
            var day = this.fromDate.getDate();
            var monthIndex = this.fromDate.getMonth();
            var year = this.fromDate.getFullYear();
            var formattedDate = year + "-" + (monthIndex + 1) + "-" + day;
            return formattedDate;
        }

        formatToDate(): string {
            //var utcDate: Date = new Date(Date.UTC(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate()));
            var day = this.toDate.getDate();
            var monthIndex = this.toDate.getMonth();
            var year = this.toDate.getFullYear();
            var formattedDate = year + "-" + (monthIndex + 1) + "-" + day;
            return formattedDate;
        }

        onChangedOptionForShowClosedInactive(): void {
            if (this.performanceDetailsPtp.length > 0) {
                this.loadP2PPerformanceDetails();
            }
        }

        loadRtg(): void {
            this.perfDate = null;
            this.isInitializing = true;
            this.acgApi.getPerformanceDetails(this.rtgId)
                .then((data) => {

                    this.rtg = data.data;
                    this.isInitializing = false;

                    if (this.rtg.performanceDetails.length > 0) {
                        this.perfDate = this.rtg.performanceDetails[0].asOfDate;
                    }

                    // Initialize the current state so that if the user elects to see historical charts
                    // we can load them using the current state
                    this.chartDataParams.level = "R";
                    this.chartDataParams.householdId = this.rtg.householdId;
                    this.chartDataParams.accountGroupType = this.accountGroupType;
                    this.chartDataParams.groupId = this.rtgId;
                    this.chartDataParams.accountId = null;
                    this.chartDataParams.boModelId = null;
                    this.chartDataParams.showClosedInactive = this.showClosedInactive;
                    this.chartDataParams.additionalData = this.rtg.accountGroupDescription + " - Account Group";

                    this.loadRtgCharts();

                    if (this.rtg.householdId) {
                        this.advisorService.getHouseholdAnalysts(this.rtg.householdId)
                            .then(response => { this.analysts = response.data || []; });
                    }
                }, err => this.isInitializing = false)
                .catch((reason) => {
                    console.log("Error during loading of RTG Performance Details");
                    console.log(reason);
                });
        }

        loadP2PPerformanceDetails = () => {
            if (this.fromDate == null || this.fromDate == undefined || this.toDate == null || this.toDate == undefined) {
                toastr.error("Date can not be blank.");
                return;
            }

            this.loadingP2PPerformanceLadda = true;

            var utcFromDate: Date = new Date(Date.UTC(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate()));
            var utcToDate: Date = new Date(Date.UTC(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate()));

            //console.log("Loading P2P data for date range: ",utcFromDate," - ",utcToDate);

            this.advisorService.getRtgPerformanceDetailsP2P(this.rtgId, utcFromDate, utcToDate, this.showClosedInactive)
                .then(response => {
                    this.performanceDetailsPtp = response.data;
                    var fdat = (this.fromDate.getMonth()) + 1 + "-" + this.fromDate.getDate() + "-" + this.fromDate.getFullYear();
                    var tdat = (this.toDate.getMonth()) + 1 + "-" + this.toDate.getDate() + "-" + this.toDate.getFullYear();
                    this.ptpCaption = "Performance from " + fdat + " to " + tdat;
                    this.ptpLineCaption = "Cumulative " + this.ptpCaption; this
                    if (this.showClosedInactive == false) {
                        this.ptpCaption2 = "Not including any accounts that may have been closed prior to end date";
                    } else {
                        this.ptpCaption2 = null;
                    }
                    //console.log("RESPONSEDATA: ", response.data);
                }, err => this.gs.showError(err)).finally(() => {
                    this.loadingP2PPerformanceLadda = false;
                });

            return;
        }

        onAccountsDdlItemSelected = (itemData) => {
            //console.log("AdvisorRtgdDashboard: onAccountsDdlItemSelected received...", itemData)
            if (itemData) {
                // clear selection in HH grid
                $("#dgHouseholds tr.acsrow").each((ind, elm) => {
                    $(elm).removeClass("acsrow");
                });

                // selecting row in dgHouseholds grid
                const dgSummary = DevExpress.ui.dxDataGrid.getInstance($("#dgHouseholds")) as DevExpress.ui.dxDataGrid;

                //SYNC selection on SummaryGrid
                this.acgs.syncDgSummaryGridSelection(itemData.level, itemData.item, this.asg.sortByField, this.asg.rootLevel, dgSummary, this.accounts);

                //let dgSummaryRowIndex;
                //if (itemData.ID == `${this.rtgId}`) {
                //    dgSummaryRowIndex = 0;
                //} else if (itemData.level == "S") {
                //    // console.log("HH row key", itemData.item);
                //    // first we need to ensure that row is expanded
                //    const dgSummaryRowKey = [this.rtgId, itemData.item.accountId]
                //        .map(m => +m);
                //    dgSummary.expandRow(dgSummaryRowKey).then(vv => {
                //        dgSummaryRowIndex = dgSummary.getRowIndexByKey(itemData.item);
                //        if (dgSummaryRowIndex >= 0) {
                //            const rowEl = dgSummary.getRowElement(dgSummaryRowIndex);
                //            $(rowEl).addClass("acsrow");
                //        }
                //    }, err => console.log(`Error during ExpandRow of dgHouseholds widget...`));
                //} else {
                //    const dgSummaryRowKey: any[] = (itemData.ID as string).split("_").map(m => +m);
                //    dgSummaryRowIndex = dgSummary.getRowIndexByKey(dgSummaryRowKey);
                //}
                //if (dgSummaryRowIndex >= 0) {
                //    const rowEl = dgSummary.getRowElement(dgSummaryRowIndex);
                //    $(rowEl).addClass("acsrow");
                //}
                // console.log(`HH row index is:`, dgSummaryRowIndex);
                this.hg_onItemSelected(itemData.item, itemData.level, itemData.caption);
            }
        }

        onChangeHistView() {
            if (this.histChartView) {
                this.loadSelectedChartData();
            } else {
                this.showHistChart = false;
            }
        }

        onChangeHistChartType() {
            this.setStackPercentAttribute();
            this.toggleDataVisibility();
            this.updateHistChartData();
        }

        onChangeHistChartDateType() {
            this.loadSelectedChartData();
        }

        onAccountsDdlReady = (ctrl) => {
            this.ctlAccountDdl = ctrl;
        }

        asg_onReady = (component) => {
            //console.log("onReady", component);
            this.asg = component;
        }

        $routerOnActivate(next, previous) {

            this.rtgId = <number>next.params.rtgId;

            this.loadRtg();

            this.loadAccounts();
        }

    }


    class AdvisorRtgDashboard implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AdvisorRtgDashboardController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/views/advisor-rtg-dashboard.html";
        }
    }
    angular.module(Constants.APP).component("advisorRtgDashboard", new AdvisorRtgDashboard());

}